document.addEventListener('DOMContentLoaded', () => {
    function recovery_inputs_handler(is_recovery_input) {
        const recovery_inputs_container = document.querySelector('#cms_third_party_claim_intimation_claim_recovery_inputs_container');

        if (is_recovery_input.checked) {
            recovery_inputs_container.classList.remove('hidden');
        } else {
            recovery_inputs_container.classList.add('hidden');
        }
    }

    let tp_claim_intimation_recovery = document.querySelector('#cms_third_party_claim_intimation_claim_recovery');

    if (tp_claim_intimation_recovery !== null) {
        recovery_inputs_handler(tp_claim_intimation_recovery)

        tp_claim_intimation_recovery.addEventListener('click', function () {
            recovery_inputs_handler(this)
        });
    }
});
